import React from 'react';
import { TabsOrentations } from '../MTabs.model';

import MTabsNavItemView from './MTabsNavItem.view';

type Props<Tabs extends string> = {
  id: Tabs;
  active?: boolean;
  classNameItem?: string;
  classNameItemSelected?: string;
  orientation?: TabsOrentations;
  onTabClick: (tab: Tabs) => void;
};

const MTabsNavItem = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  return (
    <MTabsNavItemView
      id={props.id}
      active={props.active}
      classNameItem={props.classNameItem}
      classNameSelected={props.classNameItemSelected}
      orientation={props.orientation}
      onTabClick={props.onTabClick}
    >
      {props.children}
    </MTabsNavItemView>
  );
};

MTabsNavItem.displayName = 'MTabsNavItem';

export default MTabsNavItem;
